import {Box, Divider} from '@mui/material';
import React from 'react';
import AppCard, {AppCardProps} from './AppCard';

interface BaseCardProps {
    icon?: React.ReactNode;
    headerData?: React.ReactNode;
    footerData?: React.ReactNode;
    cardProps?: AppCardProps;
    menus?: React.ReactNode;
    headerDateInSameLine?: boolean;
}

export const BaseCard: React.FC<BaseCardProps> = ({
    icon,
    headerData,
    footerData,
    cardProps,
    headerDateInSameLine,
    menus,
}) => {
    return (
        <AppCard {...cardProps} style={{marginBottom: '10px'}}>
            <Box display={'flex'} alignItems="center" justifyContent={'space-between'} width={'100%'}>
                <Box display="flex" alignItems="center" gap={0.5}>
                    {icon}
                    <Box
                        {...(headerDateInSameLine && {
                            display: 'flex',
                            width: '100%',
                        })}
                    >
                        {headerData}
                    </Box>
                </Box>
                {menus}
            </Box>
            {footerData && (
                <>
                    <Divider sx={{mb: 1}} />
                    {footerData}
                </>
            )}
        </AppCard>
    );
};

export default BaseCard;
